// extracted by mini-css-extract-plugin
module.exports = {"slide":"MemberInfoCommentList_slide_2dZcp","slide-reverse":"MemberInfoCommentList_slide-reverse_1itdL","MemberInfoCommentList":"MemberInfoCommentList_MemberInfoCommentList_7qGFE"};